<template>
  <div>
    <b-row>
      <b-col>
        <b-alert variant="info" :show="mode === 'ADD'">
          <i class="fas fa-info-circle mr-2" />
          <span v-text="alertText" />
        </b-alert>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="center">
      <b-col v-if="mode === 'EDIT'" cols="12" md="12">
        <strong v-text="'مشخصات فعلی کاربر: '" />
        <ProfileBoxPopupWrapper
          :data="item"
          deskTopPopupClass="top-230"
          nameClass="color-complementary"
        />
        <span v-text="`(${pathOr('', ['person', 'national_code'], item)})`" />
      </b-col>
      <b-col v-if="mode === 'EDIT'" cols="12" md="12" class="mt-3">
        <strong v-text="'مشخصات جدید کاربر: '" />
      </b-col>
      <b-col v-if="mode === 'ADD'" cols="12" md="6">
        <strong class="d-flex align-items-center">
          <b-form-checkbox class="mx-0" id="showName" v-model="showName" />
          <label for="showName" class="mb-0" v-text="'تغییر نام'" />
        </strong>
        <small
          class="font-weight-bold ml-4"
          v-html="`نام فعلی: <span class='text-muted'>${oldName}</span>`"
        />
      </b-col>
      <b-col cols="12" md="">
        <b-form-group
          :label="$lang.new_name"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            v-if="showName"
            slot="label"
            :label="$lang.new_name"
            :rules="$v.name.$params"
          />
          <b-form-input
            type="text"
            autocomplete="off"
            v-model="$v.name.$model"
            :state="$v.name.$dirty ? !$v.name.$error : null"
            :disabled="!showName"
          />
          <b-form-invalid-feedback v-if="!$v.name.required" id="name-feedback">
            {{ $lang.error_required | replace($lang.new_name) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="center">
      <b-col v-if="mode === 'ADD'" cols="12" md="6">
        <strong class="d-flex align-items-center">
          <b-form-checkbox class="mx-0" id="showFamily" v-model="showFamily" />
          <label for="showFamily" class="mb-0" v-text="'تغییر نام خانوادگی'" />
        </strong>
        <small
          class="font-weight-bold ml-4"
          v-html="
            `نام خانوادگی فعلی: <span class='text-muted'>${oldFamily}</span>`
          "
        />
      </b-col>
      <b-col cols="12" md="">
        <b-form-group
          :label="$lang.new_family"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            v-if="showFamily"
            slot="label"
            :label="$lang.new_family"
            :rules="$v.family.$params"
          />
          <b-form-input
            type="text"
            autocomplete="off"
            v-model="$v.family.$model"
            :state="$v.family.$dirty ? !$v.family.$error : null"
            :disabled="!showFamily"
          />
          <b-form-invalid-feedback
            v-if="!$v.family.required"
            id="family-feedback"
          >
            {{ $lang.error_required | replace($lang.new_family) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="center">
      <b-col v-if="mode === 'ADD'" cols="12" md="6">
        <strong class="d-flex align-items-center">
          <b-form-checkbox
            class="mx-0"
            id="showNationalCode"
            v-model="showNationalCode"
          />
          <label for="showNationalCode" class="mb-0" v-text="'تغییر کد ملی'" />
        </strong>
        <small
          class="font-weight-bold ml-4"
          v-html="
            `کد ملی فعلی: <span class='text-muted'>${oldNationalCode}</span>`
          "
        />
      </b-col>
      <b-col cols="12" md="">
        <b-form-group
          :label="$lang.new_national_code"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            v-if="showNationalCode"
            slot="label"
            :label="$lang.new_national_code"
            :rules="$v.nationalCode.$params"
          />
          <b-form-input
            type="text"
            minLength="10"
            maxLength="10"
            autocomplete="off"
            v-model="$v.nationalCode.$model"
            :state="$v.nationalCode.$dirty ? !$v.nationalCode.$error : null"
            :disabled="!showNationalCode"
          />
          <b-form-invalid-feedback id="nationalCode-feedback">
            <div v-if="!$v.nationalCode.required">
              {{ $lang.errors.required | replace($lang.new_national_code) }}
            </div>
            <div v-if="!$v.nationalCode.minLength">
              {{ $lang.errors.minLength | replace($lang.new_national_code) }}
            </div>
            <div v-if="!$v.nationalCode.maxLength">
              {{ $lang.errors.maxLength | replace($lang.new_national_code) }}
            </div>
            <div v-if="!$v.nationalCode.numeric">
              {{ $lang.errors.numeric | replace($lang.new_national_code) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="mode === 'EDIT'">
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.request_status"
          label-for="attachment_type"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.request_status"
            :rules="$v.status_selected.$params"
          />
          <selectFind
            :options="statusOptions"
            v-model="$v.status_selected.$model"
            label="text"
            id="value"
            :isValid="
              $v.status_selected.$dirty ? !$v.status_selected.$error : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.status_selected.$error ? 'block' : 'none',
            }"
            id="status_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.request_status) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col
        v-if="pathOr(null, ['value'], status_selected) === 3"
        cols="12"
        md="12"
      >
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.reject_reason}: `"
            :rules="$v.rejectReason.$params"
          />
          <b-form-textarea
            type="text"
            v-model="$v.rejectReason.$model"
            :rows="this.$config.form.textareaRows"
          >
          </b-form-textarea>
          <b-form-invalid-feedback
            :state="$v.rejectReason.$dirty ? !$v.rejectReason.$error : null"
          >
            <div v-if="!$v.rejectReason.required">
              {{ $lang.error_required | replace($lang.reject_reason) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-right mt-3">
        <b-button
          type="reset"
          class="mr-2"
          variant="outline-danger"
          @click="close"
        >
          <mdicon name="close" size="20" />
          {{ $lang.close }}
        </b-button>
        <b-button
          v-if="isAdmin(parentPermissions) && hasData"
          variant="success"
          @click="submit"
        >
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import {
  requiredIf,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { isAdmin, renderEumOptions } from "@/shared/utils";

export default {
  name: "person-identity-form",
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: "ADD",
    },
    oldName: {
      type: String,
      default: "",
    },
    oldFamily: {
      type: String,
      default: "",
    },
    oldNationalCode: {
      type: String,
      default: "",
    },
  },
  validations: {
    name: { required: requiredIf((vm) => vm.showName) },
    family: { required: requiredIf((vm) => vm.showFamily) },
    nationalCode: {
      required: requiredIf((vm) => vm.showNationalCode),
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
    status_selected: { required: requiredIf((vm) => vm.mode === "EDIT") },
    rejectReason: {
      required: requiredIf(
        (vm) => vm.mode === "EDIT" && vm.status_selected.value === 3
      ),
    },
  },
  data() {
    return {
      loading: false,
      showName: false,
      name: null,
      showFamily: false,
      family: null,
      showNationalCode: false,
      nationalCode: null,
      status_selected: null,
      rejectReason: null,
    };
  },
  computed: {
    hasData() {
      return !this.$v.$anyError || this.mode === "EDIT";
    },
    statusOptions() {
      return renderEumOptions("person_main_data_status");
    },
    alertText() {
      return "لطفا فقط موردی که نیاز به تغییر دارد را انتخاب نمائید از درج مجدد مشخصات صحیح خودداری کنید.";
    },
  },
  watch: {
    showName(value) {
      /* guidance: reset name when showName is false */
      if (!value) this.name = null;
    },
    showFamily(value) {
      /* guidance: reset family when showFamily is false */
      if (!value) this.family = null;
    },
    showNationalCode(value) {
      /* guidance: reset nationalCode when showNationalCode is false */
      if (!value) this.nationalCode = null;
    },
    status_selected(value) {
      const oldId = pathOr(null, ["person_main_data_status", "id"], this.item);
      const newId = pathOr(null, ["value"], value);
      const newCaption = pathOr(null, ["text"], value);
      if (oldId && oldId !== 1 && newId === 1) {
        this.status_selected = {
          text: pathOr(null, ["person_main_data_status", "caption"], this.item),
          value: pathOr(null, ["person_main_data_status", "id"], this.item),
        };
        return this.$notify.warning(
          `امکان تغییر وضعیت به "${newCaption}" نمی باشد`
        );
      }
    },
    item(value) {
      value && this.fetchData();
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    renderEumOptions,
    close() {
      this.$emit("close");
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      const payload = {
        name: this.name,
        family: this.family,
        national_code: this.nationalCode,
        person_main_data_status_id: pathOr(
          null,
          ["value"],
          this.status_selected
        ),
        reject_reason: this.rejectReason,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (!this.item) return;
      this.name = pathOr(null, ["new_name"], this.item);
      this.family = pathOr(null, ["new_family"], this.item);
      this.nationalCode = pathOr(null, ["new_national_code"], this.item);
      this.status_selected = {
        text: pathOr(null, ["person_main_data_status", "caption"], this.item),
        value: pathOr(null, ["person_main_data_status", "id"], this.item),
      };
    },
  },
  components: { ProfileBoxPopupWrapper },
};
</script>
